import React from 'react';
import moment from 'moment';
import { Row } from './OpenDates.styled';

const OpenDates = ({ openEvent }) => {
  return (
    <Row key={`${openEvent.time}`}>
      {moment.unix(openEvent.time).format('MM-DD-YYYY hh:mm A')}
    </Row>
  );
};

export default OpenDates;
